import React, { useEffect, useState } from "react";
import { useLoader } from "../../Context/LoaderContext";
import { Button, Divider, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../Context/AppContext/AppContext";
import CreditSummary from "./components/CreditSummary/CreditSummary";
import CreditSelector from "./components/CreditSelector/CreditSelector";
import "./index.scss";

const CreditPurchase: React.FC = () => {
  const navigate = useNavigate();
  const { setLoading, setLoadingMessage } = useLoader();
  const { currentRegion, creditPlan } = useAppContext();

  const [noOfSelectedCredits, setNoOfSelectedCredits] = useState<number | null>(
    100,
  );

  const userCurrencyCode = currentRegion === "IND" ? "INR" : "USD";
  const userCurrencySymbol = currentRegion === "IND" ? "₹" : "$";

  const initialize = async () => {};

  useEffect(() => {
    if (creditPlan) {
      initialize();
    } else {
      setLoading(true);
      setLoadingMessage("Loading credit plan...");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditPlan]);

  return (
    <section className="dashboard-page hide-scroll-bar">
      <div className="credit-purchase-page-header">
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
        />
        <Typography.Title level={4} style={{ margin: 0 }} ellipsis>
          Buy QualifyMe Credits
        </Typography.Title>
      </div>
      <Divider style={{ margin: 0 }} />
      <div className="credit-purchase-page-content">
        {creditPlan && (
          <div className="credit-purchase-page-content-right">
            <CreditSelector
              creditPlan={creditPlan}
              userCurrencyCode={userCurrencyCode}
              userCurrencySymbol={userCurrencySymbol}
              noOfSelectedCredits={noOfSelectedCredits}
              setNoOfSelectedCredits={setNoOfSelectedCredits}
            />
          </div>
        )}

        <div className="credit-purchase-page-content-left">
          {creditPlan && (
            <CreditSummary
              noOfSelectedCredits={noOfSelectedCredits}
              userCurrencyCode={userCurrencyCode}
              userCurrencySymbol={userCurrencySymbol}
              creditPlan={creditPlan}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default CreditPurchase;
